// extracted by mini-css-extract-plugin
module.exports = {"blur70":"_25J7OlBv5LRiKvJNs_eLl5"};